// extracted by mini-css-extract-plugin
export default {"imageDrop":"drag-upload_imageDrop__K4zgU","dragOver":"drag-upload_dragOver__WJ5Jm"};